import { collection, getCountFromServer, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from '../config/firebase';
import { dataCache, CACHE_TTL } from './cache/dataCache';
import { CACHE_KEYS } from './cache/cacheKeys';

export interface DashboardStats {
  users: number;
  products: number;
  pending_products: number;
  user_products: number;
  lastProductId: number | null;
  fetchedAt: number;
}

export class DashboardService {
  static async fetchStats(): Promise<DashboardStats> {
    const [usersSnap, productsSnap, pendingSnap, userProductsSnap, lastProductSnap] = await Promise.all([
      getCountFromServer(collection(db, 'users')),
      getCountFromServer(collection(db, 'products')),
      getCountFromServer(collection(db, 'pending_products')),
      getCountFromServer(collection(db, 'user_products')),
      getDocs(query(collection(db, 'products'), orderBy('id', 'desc'), limit(1))),
    ]);

    let lastProductId: number | null = null;
    if (!lastProductSnap.empty) {
      lastProductId = lastProductSnap.docs[0].data().id ?? null;
      if (lastProductId !== null) {
        dataCache.set(CACHE_KEYS.lastProductId, lastProductId);
      }
    }

    return {
      users: usersSnap.data().count,
      products: productsSnap.data().count,
      pending_products: pendingSnap.data().count,
      user_products: userProductsSnap.data().count,
      lastProductId,
      fetchedAt: Date.now(),
    };
  }

  static getCachedStats(): DashboardStats | null {
    return dataCache.get<DashboardStats>(CACHE_KEYS.dashboardStats, CACHE_TTL.dashboard);
  }

  static invalidateStats(): void {
    dataCache.invalidate(CACHE_KEYS.dashboardStats);
  }
}
